import * as Sentry from '@sentry/nextjs';

const isServer = typeof window === 'undefined';
const isProduction = process.env.NODE_ENV === 'production';

export function logInfo(message: string, sendToSentry = false) {
  if (isServer || !isProduction) {
    console.info(message);
  }

  if (isProduction && sendToSentry) {
    Sentry.captureMessage(message, 'info');
  }
}
